import React, {PureComponent} from 'react';
import hoopUrl from "./model/hoop_other.obj";
import hoopImg from "./images/hoop.jpg";
import groundImg from "./images/basketball.jpg";

//const THREE = require('three');
const THREE = window.THREE;
const THREEx = window.THREEx;

//const OrbitControls = require('three-orbitcontrols');
const OBJLoader = require('three-obj-loader');
const Ammo = require('ammonext');
const cookies = require('browser-cookies');
OBJLoader(THREE);
/*
function roundf(number) { // Round float number to x.xxx.
    return Math.trunc(number * 1000) / 1000;
}
*/
export default class ArBasketball extends PureComponent {

    constructor() {
        super();
        this.width = 0;
        this.height = 0;

		this.gameScale = cookies.get( 'gameScale' );
		if (this.gameScale === null) this.gameScale = '0.2';
		this.gameScale = parseFloat( this.gameScale );

        this.renderer = new THREE.WebGLRenderer( {antialias: true, alpha: true} );
		this.animate = this.animate.bind( this );
        this.createRigidBody = this.createRigidBody.bind( this );
        this.enlargeGameScale = this.enlargeGameScale.bind( this );
        this.reduceGameScale = this.reduceGameScale.bind( this );
        this.physicsWorld = null;
        this.clock = new THREE.Clock();
        this.rigidBodies = [];
        this.tmpTrans = null;
        this.colGroupPlane = 1;
        this.colGroupRedBall = 2;
        this.colGroupGreenBall = 4;
        this.raycaster = new THREE.Raycaster();
        this.mouseCoords = new THREE.Vector2();
        this.posV3 = new THREE.Vector3();
		this.posV3_2 = new THREE.Vector3();
        this.quat = new THREE.Quaternion();
        this.playCount = 0;
        this.goalCount = 0;
    }

    componentDidMount() {
        this.width = this.divElement.offsetWidth;
        this.height = this.divElement.offsetHeight;

        this.underPos = -3;
        this.playSizeZ = 5.7;
        this.hoopStandPosZ = this.playSizeZ + 0.5;
        this.hoopBackPosZ = this.playSizeZ - 0.15;
        this.hoopNetPosZ = this.playSizeZ - 0.43;

        this.tmpTrans = new Ammo.btTransform();
        this.createBallModel();
        this.setupPhysicsWorld();
        this.setupGraphicWorld();
        this.createPlane();
        this.createHoop(1);
        this.createHoop(-1);
        this.initInput();

//      this.renderFrame();
		this.animate();
    }

	initializeAr() {
		this.arToolkitSource = new THREEx.ArToolkitSource( { sourceType : 'webcam' } );
		let self = this;

		function onResize() {
			self.arToolkitSource.onResize();
			self.arToolkitSource.copySizeTo( self.renderer.domElement );
			if ( self.arToolkitContext.arController !== null )
				self.arToolkitSource.copySizeTo( self.arToolkitContext.arController.canvas );
		}

		this.arToolkitSource.init( function onReady() {
			onResize();
		} );

		window.addEventListener( 'resize', function() {
			onResize();
		} );

		this.arToolkitContext = new THREEx.ArToolkitContext( {
			cameraParametersUrl: 'data/camera_para.dat',
			detectionMode: 'mono' } );

		this.arToolkitContext.init( function onCompleted() {
			self.camera.projectionMatrix.copy( self.arToolkitContext.getProjectionMatrix() );
		} );

		this.markerRoot = new THREE.Group();
		this.scene.add( this.markerRoot );
		// eslint-disable-next-line
		let markerControls = new THREEx.ArMarkerControls( this.arToolkitContext, this.markerRoot, {
			type: 'pattern',
			// patternUrl: "data/hiro.patt"
			patternUrl: "data/kanji.patt" } );
	}

    initInput() {
        const ballRadius = 0.2;
        const margin = 0.05;
		const ballMass = 0.3;
        window.addEventListener( 'mouseup', event => {
            this.mouseCoords.set( ( event.clientX / window.innerWidth ) * 2 - 1,
                                  -( event.clientY / window.innerHeight ) * 2 + 1);
            this.raycaster.setFromCamera( this.mouseCoords, this.camera );

            let ballObj = this.ballModel.clone();
            ballObj.checkGoal = false;
            let ballShape = new Ammo.btSphereShape( ballRadius );
            ballShape.setMargin( margin );

            this.posV3.copy( this.raycaster.ray.direction );
            this.posV3.add( this.raycaster.ray.origin );

			this.posV3_2.copy( this.posV3 );
			this.mainGroup.worldToLocal( this.posV3 );

            this.quat.set( 0, 0, 0, 1 );
            let ballBody = this.createRigidBody(
					ballObj, ballShape, ballMass, this.posV3, this.quat );
            ballBody.setFriction( 0.5 );

//			this.posV3.copy( self.raycaster.ray.direction );
//			this.posV3.multiplyScalar( 14 );
//			this.posV3_2.multiplyScalar( 8 );
			this.posV3_2.multiplyScalar( 14 );
			this.mainGroup.worldToLocal( this.posV3_2 );

//			ballBody.setLinearVelocity(
//				new Ammo.btVector3( this.posV3.x, this.posV3.y, this.posV3.z ) );
			ballBody.setLinearVelocity(
				new Ammo.btVector3( this.posV3_2.x, this.posV3_2.y, this.posV3_2.z ) );
//			ballBody.setLinearVelocity( new Ammo.btVector3( 6.4, 3, -3 ) );

            this.playCount++;
            if (this.playNum) this.playNum.innerHTML = this.playCount;
        }, false );
    }

    setupPhysicsWorld() {
        let collisionConfiguration  = new Ammo.btDefaultCollisionConfiguration(),
            dispatcher              = new Ammo.btCollisionDispatcher( collisionConfiguration ),
            overlappingPairCache    = new Ammo.btDbvtBroadphase(),
            solver                  = new Ammo.btSequentialImpulseConstraintSolver();

        this.physicsWorld = new Ammo.btDiscreteDynamicsWorld(
        		dispatcher, overlappingPairCache, solver, collisionConfiguration );
        this.physicsWorld.setGravity( new Ammo.btVector3( 0, -10, 0 ) );
    }

    setupGraphicWorld() {
        this.renderer.setSize( this.width, this.height );
        this.divElement.appendChild( this.renderer.domElement );
        this.renderer.setClearColor( 0x000000, 0 );
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        this.renderer.gammaInput = true;
        this.renderer.gammaOutput = true;

		this.camera = new THREE.PerspectiveCamera( 60, this.width / this.height, 0.6, 50 );
//		this.camera.position.set( 2.8, 0.5, this.playSizeZ / 2 );
//		this.camera = new THREE.Camera();

        this.scene = new THREE.Scene();
        this.initializeAr();

        this.mainGroup = new THREE.Group();
//		this.createAxises();
		this.markerRoot.add( this.mainGroup );

        let ambient = new THREE.AmbientLight( 0xFFFFFF, 0.4 );
        this.scene.add( ambient );

        let light = new THREE.DirectionalLight( 0xFFFFFF, 1.5 );
        light.position.set( 5, 5, 5 );
        light.castShadow = true;
        this.scene.add( light );
        light.shadow.mapSize.width = 4096;
        light.shadow.mapSize.height = 4096;
        light.shadow.camera.near = 0.5;
        light.shadow.camera.far = 20;

        let loader = new THREE.OBJLoader();

        loader.load( hoopUrl, object => {
            object.castShadow = true;
            let box3 = new THREE.Box3().setFromObject( object );
            let colorObj = {"Object01":0xFFFFFF, "Object03":0x000000, "Plane01":0xFFFFFF}
            object.traverse( function(child) {
                if (child instanceof THREE.Mesh) {
                    if (child.name === "Object03" || child.name === "Object01") {
                    	child.visible = false;
                    } else {
                        // child.castShadow = true;
                        child.material.color.setHex( colorObj[child.name] );
                        child.position.y -= box3.min.y;
                    }
                }
            } );
            const scaleVal = 0.00025;
            object.scale.set( scaleVal, scaleVal, scaleVal );
            object.position.z = this.playSizeZ;
            object.position.y = this.underPos + 2.69;
//          this.scene.add( object );
  			this.mainGroup.add( object );
            let cloneObj = object.clone();
            cloneObj.rotation.y = Math.PI;
            object.position.z = this.playSizeZ * -1;
//          this.scene.add( cloneObj );
			this.mainGroup.add( cloneObj );

			let box = new THREE.Box3();
			box.setFromObject( this.mainGroup );
			this.mainGroupMinY = box.min.y;
//			console.log( 'min y: ' + roundf( box.min.y ) );

			this.mainGroup.scale.set(
					this.gameScale, this.gameScale, this.gameScale );
/*
			box.setFromObject( self.mainGroup );
			console.log( 'min y after scale: ' + roundf( box.min.y ) );
			console.log( 'computed min y after scale: ' +
					roundf( this.mainGroupMinY * this.gameScale ) );
*/
			this.setMainGroupYPosition();
        } );
    } // setupGraphicWorld

	setMainGroupYPosition() {
//		this.box.setFromObject( this.mainGroup );
//		this.mainGroup.position.y = Math.abs( this.box.min.y );
		this.mainGroup.position.y =
				Math.abs( this.mainGroupMinY * this.gameScale );
	}

	createAxises() {
		let material = new THREE.LineBasicMaterial( {color: 'red'} );
		let geometry = new THREE.Geometry();
		geometry.vertices.push( new THREE.Vector3( 0, 0, 0 ),
		                        new THREE.Vector3( 5, 0, 0 ) );
		this.markerRoot.add( new THREE.Line( geometry, material ) );

		material = new THREE.LineBasicMaterial( {color: 'green'} );
		geometry = new THREE.Geometry();
		geometry.vertices.push( new THREE.Vector3( 0, 0, 0 ),
	  	                        new THREE.Vector3( 0, 5, 0 ) );
		this.markerRoot.add( new THREE.Line( geometry, material ) );

		material = new THREE.LineBasicMaterial( {color: 'blue'} );
		geometry = new THREE.Geometry();
		geometry.vertices.push( new THREE.Vector3( 0, 0, 0 ),
	                            new THREE.Vector3( 0, 0, 5 ));
		this.markerRoot.add( new THREE.Line( geometry, material ) );
	}

    createBallModel() {
        // let ballTextureLoader = new THREE.TextureLoader();
        // let ballTexture = ballTextureLoader.load(ballImg);
        // let ballNormalTextureLoader = new THREE.TextureLoader();
        // let ballNormalTexture = ballNormalTextureLoader.load( ballNormalImg );
        let ballGeo = new THREE.SphereGeometry( 0.17, 32, 32 );
//      let ballMat = new THREE.MeshPhongMaterial( {color: 'white'} ); // map:ballTexture, normalMap:ballNormalTexture
        let ballMat = new THREE.MeshPhongMaterial( {color: '#C16C4D'} );
        this.ballModel = new THREE.Mesh( ballGeo, ballMat );
        this.ballModel.castShadow = true;
    }

    createHoop(side) {
        let posArr = [{x: 0, y: this.underPos +1.6, z: this.hoopStandPosZ * side},
                      {x: 0, y: this.underPos + 3.4, z: this.hoopBackPosZ * side}];
        let sizeArr = [{x: 0.15, y: 4.4, z: 0.15}, {x: 1.6, y: 0.9, z: 0.08}];
        let quat = {x: 0, y: 0, z: 0, w: 1};
        let mass = 0;

        let hoopTexture = new THREE.TextureLoader().load( hoopImg );
        let hoopBackGeo = new THREE.BoxGeometry( sizeArr[1].x, sizeArr[1].y, sizeArr[1].z );
        let hoopBackMat = new THREE.MeshPhongMaterial( {color: 0xFFFFFF, map: hoopTexture} );
        let hoopBackMesh = new THREE.Mesh( hoopBackGeo, hoopBackMat );
        hoopBackMesh.receiveShadow = true;
        hoopBackMesh.castShadow = true;
        hoopBackMesh.position.set( posArr[1].x, posArr[1].y, posArr[1].z );
//      this.scene.add( hoopBackMesh );
		this.mainGroup.add( hoopBackMesh );

        let hoopRadius = 0.22, hoopPosY = this.underPos + 3.13, hoopPosZ = this.hoopNetPosZ * side;
        let i = 0;
        while (i < 36) {
            let pos = {x: Math.cos(Math.PI/18 * i) * hoopRadius,
                       y: hoopPosY,
                       z: Math.sin(Math.PI/18 * i) * hoopRadius + hoopPosZ};
            posArr.push(pos);
            let testGeo = new THREE.SphereGeometry( 0.01, 12, 12 );
            let testMat = new THREE.MeshPhongMaterial( {color: 0x888888} );
            let testMesh = new THREE.Mesh( testGeo, testMat );
            testMesh.position.set( pos.x, pos.y, pos.z );
//          this.scene.add( testMesh );
			this.mainGroup.add( testMesh );
            i++;
        }

        posArr.forEach( (pos, idx) => {
            let transform = new Ammo.btTransform();
            transform.setIdentity();
            transform.setOrigin( new Ammo.btVector3( pos.x, pos.y, pos.z ) );
            transform.setRotation( new Ammo.btQuaternion( quat.x, quat.y, quat.z, quat.w ) );
            let motionState = new Ammo.btDefaultMotionState( transform );

            let colShape, size;
            if (idx < 2) {
                size = sizeArr[idx];
                colShape = new Ammo.btBoxShape( new Ammo.btVector3( size.x * 0.5, size.y * 0.5, size.z * 0.5 ) );
            } else {
                colShape = new Ammo.btSphereShape( 0.01 );
            }
            colShape.setMargin( 0.05 );

            let localInertia = new Ammo.btVector3( 0, 0, 0 );
            colShape.calculateLocalInertia( mass, localInertia );

            let rbInfo = new Ammo.btRigidBodyConstructionInfo( mass, motionState, colShape, localInertia );
            let body = new Ammo.btRigidBody( rbInfo );
            this.physicsWorld.addRigidBody( body );
        } );
    }

    createPlane() {
        let width = 11.38, length = 6.5;
        let size = {x: length+ 0.3, y: 0.1, z: width + 0.3};
        let pos = {x: 0, y: this.underPos, z: 0};
        let quat = {x: 0, y: 0, z: 0, w: 1};
        let mass = 0;

        let planeGeo = new THREE.BoxGeometry( width + 0.5, 0.1, length + 0.3 );
        let planeTexture = new THREE.TextureLoader().load( groundImg );
        let planeMat = new THREE.MeshPhongMaterial( {map: planeTexture} ); // color: 0x888888
        let planeMesh = new THREE.Mesh( planeGeo, planeMat );
        planeMesh.receiveShadow = true;
        planeMesh.position.y = this.underPos;
        planeMesh.rotation.y = Math.PI / 2;
//      this.scene.add( planeMesh );
        this.mainGroup.add( planeMesh );

        let transform = new Ammo.btTransform();
        transform.setIdentity();
        transform.setOrigin( new Ammo.btVector3( pos.x, pos.y, pos.z ) );
        transform.setRotation( new Ammo.btQuaternion( quat.x, quat.y, quat.z, quat.w ) );
        let motionState = new Ammo.btDefaultMotionState( transform );

        let colShape = new Ammo.btBoxShape( new Ammo.btVector3( size.x * 0.5, size.y * 0.5, size.z * 0.5 ) );
        colShape.setMargin( 0.05 );

        let localInertia = new Ammo.btVector3( 0, 0, 0 );
        colShape.calculateLocalInertia( mass, localInertia );

        let rbInfo = new Ammo.btRigidBodyConstructionInfo( mass, motionState, colShape, localInertia );
        let body = new Ammo.btRigidBody( rbInfo );
        this.physicsWorld.addRigidBody( body );
    }

	saveGameScale() {
		let n = Math.round( this.gameScale * 100 ) / 100;
		cookies.set( 'gameScale', n.toString(), {expires: 365} );
	}

	enlargeGameScale() {
		this.gameScale += 0.03;
		this.saveGameScale();
		this.mainGroup.scale.set(
				this.gameScale, this.gameScale, this.gameScale );
		this.setMainGroupYPosition();
	}

	reduceGameScale() {
		if (this.gameScale <= 0.1) return;
		this.gameScale -= 0.03;
		this.saveGameScale();
		this.mainGroup.scale.set(
				this.gameScale, this.gameScale, this.gameScale );
		this.setMainGroupYPosition();
	}

    updatePhysics(deltaTime) {
        // Step world
        this.physicsWorld.stepSimulation( deltaTime, 10 );
        // Update rigid bodies

        let i = 0;
        while (i < this.rigidBodies.length) {
            let objThree = this.rigidBodies[i];
            let objAmmo = objThree.userData.physicsBody;
            let ms = objAmmo.getMotionState();
            if ( ms ) {
                ms.getWorldTransform( this.tmpTrans );
                let p = this.tmpTrans.getOrigin();
                let q = this.tmpTrans.getRotation();
                objThree.position.set( p.x(), p.y(), p.z() );
                objThree.quaternion.set( q.x(), q.y(), q.z(), q.w() );
                if (p.y() > 0 && objThree.checkGoal === false) {
                    if (this.checkGoalObj( objThree )) {
                        this.goalCount++;
                        if (this.goalNum) this.goalNum.innerHTML = this.goalCount;
                        objThree.checkGoal = true;
                    }
                }
            }
			i++;
		}
    }

    checkGoalObj(obj) {
        var checkVal = false;
        [1, -1].forEach( side => {
            let hPos = {x: 0, y: this.underPos + 3.13, z: this.hoopNetPosZ * side};
            let oPos = obj.position;
            let dis = Math.sqrt(Math.pow(hPos.x - oPos.x, 2) +
                                Math.pow(hPos.y - oPos.y, 2) +
                                Math.pow(hPos.z - oPos.z, 2));
            if (dis < 0.1) checkVal = true;
        });
        return checkVal;
    }

	animate() {
		// Update artoolkit on every frame.
		if (this.arToolkitSource.ready !== false) {
			this.arToolkitContext.update( this.arToolkitSource.domElement );

			if (!('wasMarkerDetected' in this)) this.wasMarkerDetected = false;
			if (this.markerRoot.visible) {
				this.fixMarkerRootPosition();
				this.wasMarkerDetected = true;
			} else {
				if (this.wasMarkerDetected) this.markerRoot.visible = true;
			}
//			console.log(this.markerRoot.visible);
		}

   	    let deltaTime = this.clock.getDelta();
		this.updatePhysics( deltaTime );

		this.renderer.render( this.scene, this.camera );
		requestAnimationFrame( this.animate );
	}

	fixMarkerRootPosition() {
		const lastPositionsCount = 100;
		if (!('markerRootPositions' in this)) this.markerRootPositions = [];
		if (!('markerRootRotations' in this)) this.markerRootRotations = [];
		this.markerRootPositions.push( this.markerRoot.position.toArray() );
		this.markerRootRotations.push( this.markerRoot.rotation.toArray() );

		if (this.markerRootPositions.length > lastPositionsCount)
			this.markerRootPositions.splice(
					0, this.markerRootPositions.length - lastPositionsCount);

		if (this.markerRootRotations.length > lastPositionsCount)
			this.markerRootRotations.splice(
					0, this.markerRootRotations.length - lastPositionsCount);


		if (this.markerRootPositions.length === lastPositionsCount) {
			let xSum = 0, ySum = 0, zSum = 0;
			for (let p of this.markerRootPositions) {
				xSum += p[0];
				ySum += p[1];
				zSum += p[2];
			}
			this.markerRoot.position.set(
					xSum / lastPositionsCount,
					ySum / lastPositionsCount,
					zSum / lastPositionsCount);
		}

		if (this.markerRootRotations.length === lastPositionsCount) {
			let xSum = 0, ySum = 0, zSum = 0;
			for (let p of this.markerRootRotations) {
				xSum += p[0];
				ySum += p[1];
				zSum += p[2];
			}
			this.markerRoot.rotation.set(
					xSum / lastPositionsCount,
					ySum / lastPositionsCount,
					zSum / lastPositionsCount);
		}
	}

    createRigidBody(threeObject, physicsShape, mass, pos, quat) {
        threeObject.position.copy( pos );
        threeObject.quaternion.copy( quat );

        let transform = new Ammo.btTransform();
        transform.setIdentity();
        transform.setOrigin( new Ammo.btVector3( pos.x, pos.y, pos.z ) );
        transform.setRotation( new Ammo.btQuaternion( quat.x, quat.y, quat.z, quat.w ) );
        let motionState = new Ammo.btDefaultMotionState( transform );

        let localInertia = new Ammo.btVector3( 0, 0, 0 );
        physicsShape.calculateLocalInertia( mass, localInertia );

        let rbInfo = new Ammo.btRigidBodyConstructionInfo( mass, motionState, physicsShape, localInertia );
        let body = new Ammo.btRigidBody( rbInfo );

        threeObject.userData.physicsBody = body;

//		this.scene.add( threeObject );
		this.mainGroup.add( threeObject );

        if ( mass > 0 ) {
            this.rigidBodies.push( threeObject );
            // Disable deactivation
            body.setActivationState( 4 );
        }
        this.physicsWorld.addRigidBody( body );
        return body;
    }

    render() {
		/*
		return (
			<div style={{width: '99%'}}>
				<div style={{
						position: 'fixed',
						backgroundColor: 'green',
						width: '100%'}}>
					<span style={{float: 'left', backgroundColor: 'blue',
								width: 40,
								height: 40}}></span>
					<span style={{float: 'right', backgroundColor: 'red',
								width: 40,
								height: 40}}></span>
				</div>
			</div>);
		*/

        return (
            <div className='basketball'ref={ (divElement) => this.divElement = divElement }>
				<div style={{position: 'absolute', width: '100%'}}>

					<span className='counter' style={{float: 'left'}}>
						<span className='counter-item scorecard'
							  ref={ (goalNum) => this.goalNum = goalNum }>0</span>
					</span>

					<span style={{float: 'right' }}>
						<input type='button' value='+' onClick={ this.enlargeGameScale }/>
						<input type='button' value='-' onClick={ this.reduceGameScale }/>
					</span>

				</div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/ArBasketball.js